var React = require('react');

function TickSolutions (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector","opacity":"0.55","d":"M2.38153 7.31146L5.59395 12.7435C8.92321 7.54516 12.6613 2.98908 16.0492 0.360936C16.8084 -0.340004 17.9766 0.06892 17.1589 0.828199C13.3622 4.74143 10.4421 9.18066 7.46306 16.1312C6.29489 16.9489 4.95146 17.3578 4.30892 16.5984L0.103397 9.06366C-0.480629 8.12916 1.56358 5.9681 2.38132 7.31146L2.38153 7.31146Z","fill":"white"}));
}

TickSolutions.defaultProps = {"width":"18","height":"17","viewBox":"0 0 18 17","fill":"none"};

module.exports = TickSolutions;

TickSolutions.default = TickSolutions;
